/**
 * @generated SignedSource<<e8eccd4708f399924530b6d052f40f3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditMainGeneral_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CitySelect_data">;
  readonly " $fragmentType": "PackageEditMainGeneral_data";
};
export type PackageEditMainGeneral_data$key = {
  readonly " $data"?: PackageEditMainGeneral_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMainGeneral_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMainGeneral_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CitySelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "46b5e2e03b779efa89d3ddb9babd732f";

export default node;
